import { Button, Col, Form, Row, Checkbox } from "antd";
import ModalComponent from "../ModalComponent";
import { showNotitfication } from "../../utils/Utils";
import {
  toSavePayment,
  toSendMyList,
} from "../../apis/actions/paymentMethods.actions";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../apis/store";
import { useEffect, useState } from "react"; // Import useState
import { useTranslation } from "react-i18next";
import { resetState, setShowPaiement } from "../../apis/slices/globalSlice";
import { setWalletAmount } from "../../apis/slices/globalSlice";
import { toGetProfil } from "../../apis/actions/auth.actions";
import RewardModal from "../../domains/pages/Shop/RewardModal";

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  amounts: number;
  cart_id: string;
}

const PartialPayment = ({ isOpen, setIsOpen, amounts, cart_id }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const [form] = Form.useForm();
  const [payAll, setPayAll] = useState(false);
  const { t, i18n } = useTranslation();
  const [orderId, setOrderId] = useState("");
  const [retryAmount, seTRetryAmount] = useState(0);
  const [showRetry, SetShowRetry] = useState(false);
  const [rewardLoyalty, setRewardLoyalty] = useState("");
  const { profil } = useSelector((state: RootState) => state?.login);
  const { donationAmount, loyaltyType, amount } = useSelector(
    (state: RootState) => state?.global
  );
  const total_amount = Number(amount) + Number(donationAmount);
  useEffect(() => {
    dispatch(toGetProfil(i18n.language));
  }, [dispatch]);
  const toPayAllAmount = async () => {
    if (profil?.data?.wallet_balance < amount) {
      showNotitfication(t("payment.insufficient_wallet"), "error");
      return;
    } else {
      const paymentData = {
        amount: amount,
        transaction_id: "",
        cart_id: cart_id,
        payment_type: "wallet",
        donation_amount: Number(donationAmount),
        loyalty_type: loyaltyType,
        loyalty_phone: profil?.data?.phone,
      };
      const response = await dispatch(
        toSavePayment({ data: paymentData, lang: i18n.language }) as any
      );
      if (response?.payload?.data.result?.code === 200) {
        if (response?.payload?.data.result?.require_alternate_phone) {
          showNotitfication(
            t("profile.order.cart.successNotComplete"),
            "success"
          );
          dispatch(resetState());
          dispatch(setShowPaiement(false));
          setIsOpen(false);
          form.resetFields();
          setOrderId(response?.payload?.data.result?.order_id);
          seTRetryAmount(response?.payload?.data.result?.amount);
          setRewardLoyalty(loyaltyType);
          setTimeout(() => {
            SetShowRetry(true);
          }, 2800);
          return;
        }
        showNotitfication(t("profile.order.cart.success"), "success");
        dispatch(resetState());
        dispatch(setShowPaiement(false));
        setIsOpen(false);
        form.resetFields();
      } else {
        showNotitfication(
          response?.payload?.data.result?.message,
          "error",
          true
        );
      }
    }
  };
  useEffect(() => {
    if (payAll) {
      form.setFieldsValue({
        wallet_Amount: total_amount,
      });
    }
  }, [payAll, amount]);
  const handlePayment = async () => {
    await form.validateFields();
    const values = form.getFieldsValue();
    dispatch(setWalletAmount(Number(values.wallet_Amount)));
    setIsOpen(false);
    dispatch(setShowPaiement(false));
    form.resetFields();
  };
  const closeModal = () => {
    setIsOpen(false);
    setPayAll(false);
    form.resetFields();
  };
  return (
    <div>
      <ModalComponent
        title=""
        open={isOpen}
        onClose={closeModal}
        closeOnOutsideClick={true}
        width={500}
      >
        <Row justify={"center"}>
          <p>
            <h6 className="mb-4 pe-lg-1 mt-20 neutral-1000 ac--color-primary ac--font-expo">
              {t("partial_payment.PayWallet")}
            </h6>
          </p>{" "}
        </Row>
        <span className="mb-4 pe-lg-1 mt-20 ac--font-expo text-xl font-black text-black">
          {t("partial_payment.totalAmount")}
          {" : "}
          <span className="text-neutral-500 font-normal">
            <i
              className="icon-saudi_riyal"
              style={{ fontStyle: "normal", marginRight: 2 }}
            />
            {total_amount}
          </span>
        </span>
        <Form form={form} layout="vertical" className="mt-20">
          <Row gutter={16}>
            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                label={t("partial_payment.paidAmount")}
                name="wallet_Amount"
                rules={[
                  {
                    required: true,
                    message: t("profile.messages.6"),
                  },
                ]}
                labelCol={{ className: "text-md-bold" }}
              >
                <input
                  type="number"
                  className="ac--input ac--font-expo"
                  disabled={payAll}
                  onChange={(e) => {
                    let value = e.target.value;

                    // Disallow non-numeric characters (excluding dot)
                    value = value.replace(/[^\d.]/g, "");

                    // Prevent multiple dots or empty string
                    if ((value.match(/\./g) || []).length > 1 || value === "") {
                      return;
                    }

                    let numericValue = parseFloat(value);
                    if (isNaN(numericValue)) {
                      form.setFieldsValue({ wallet_Amount: "" });
                      setPayAll(false);
                      return;
                    }

                    // Prevent negative values
                    if (numericValue < 0) numericValue = 0;

                    // If more than amount, clamp and check payAll
                    if (numericValue >= total_amount) {
                      numericValue = total_amount;
                      setPayAll(true);
                    } else {
                      setPayAll(false);
                    }

                    form.setFieldsValue({ wallet_Amount: numericValue });
                  }}
                />
              </Form.Item>
            </Col>
            <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
              <Form.Item>
                <Checkbox
                  style={{ marginTop: "3rem" }}
                  className="ac--font-expo"
                  checked={payAll}
                  onChange={(e) => {
                    setPayAll(e.target.checked);
                    if (e.target.checked) {
                      form.setFieldsValue({ wallet_Amount: amount });
                    } else {
                      form.setFieldsValue({ wallet_Amount: "" });
                    }
                  }}
                >
                  {t("partial_payment.fullAmount")}
                </Checkbox>
              </Form.Item>
            </Col>
            <span className="mb-4 pe-lg-1 mt-20 ac--font-expo neutral-500">
              {t("profile.balance")}{" "}
              <span className="neutral-500 font-normal">
                (
                <i
                  className="icon-saudi_riyal"
                  style={{ fontStyle: "normal", marginRight: 2 }}
                />
                {profil?.data?.wallet_balance})
              </span>
            </span>
          </Row>
          <Row className="mt-20" justify="end">
            <Button
              className="text-md ac--btn-edit-save"
              onClick={payAll ? toPayAllAmount : handlePayment}
            >
              {payAll ? (
                <>{t("profile.order.cart.payment")}</>
              ) : (
                <>{t("partial_payment.rest")}</>
              )}
            </Button>
          </Row>
        </Form>
      </ModalComponent>
      <RewardModal
        open={showRetry}
        amount={retryAmount}
        order_id={orderId}
        loyaltyType={rewardLoyalty}
        onClose={() => SetShowRetry(false)}
      />
    </div>
  );
};

export default PartialPayment;
